
import { Person } from './domain';
import { fetchRequest } from './';
import { worksheetMessage, WorksheetResult } from './worksheet-service';

const service = 'cachemanager';
const url = () => `/${service}/process`;

export type UserListResult = WorksheetResult<Person[]>;

type UserArgs = {
  userIds: string[];
};

const cache: object = {};
function cacheCodeset(args: UserArgs, response?: WorksheetResult) {
  if (args) {
    const key = (args.userIds || []).join(',');

    if (!response) {
      return cache[key];
    } else {
      if (response.success) {
        cache[key] = response;
      }
    }
  }
}

export const getUsersRequest = fetchRequest<UserArgs, UserListResult>({
  method: 'post',
  url,
  body: (args: UserArgs) => worksheetMessage(args, 'getusers', service),
  cacheResult: (args) => cacheCodeset(args),
  onResult: cacheCodeset,
});

export type UserApi = {
  add(list: Person[]): void;
  one(id: string): Person;
  list(ids: string[]): Promise<Person[]>;
  all(): Person[];
};

export function userApi(initial?: Person[]): UserApi {
  const map: Map<string, Person> = new Map();

  function add(list: Person[]) {
    if (list) {
      list.forEach((a) => {
        if (a.userId) {
          map.set(a.userId, a);
        }
      });
    }
  }
  add(initial);

  async function resolveIds(userIds: string[]) {
    const response = await getUsersRequest({ userIds });
    if (response?.result?.length) {
      add(response.result);
    }
  }

  async function list(ids: string[]): Promise<Person[]> {
    if (!ids?.length) {
      return [];
    }

    await resolveIds(ids);

    const unresolved = [];
    const persons = [];

    ids.forEach((a) => {
      const v = map.get(a);
      if (!v) {
        unresolved.push(v);
      } else {
        persons.push(v);
      }
    });

    return persons;
  }
  function one(id: string) {
    const v = map.get(id);
    if (!v) {
      console.log('missing person', v);
    }
    return v;
  }

  function all() {
    return Array.from(map.values());
  }

  return {
    add,
    list,
    one,
    all,
  };
}
